<template>
  <div class="box" :class="{'disabled':lock}">
    <div class="login" :class="{'login_disabled':lock}">{{text}}</div>
  </div>
</template>

<script>
import { codeSms } from '@/api/crm'
export default {
  data () {
    return {
      lock: false,
      text: '获取验证码'
    }
  },
  methods: {
    getCode (phone, type) {
      if (this.lock) {
        return
      }

      codeSms(phone, type).then(res => {
        if (res.data.success) {
          this.$message({
            message: '发送成功',
            type: 'success'
          })
          this.lock = true
          this.text = '已发送 (' + 120 + 's)'
          let i = 119
          const timer = setInterval(() => {
            this.text = '已发送 (' + i + 's)'
            i--
            if (i < 0) {
              this.lock = false
              this.text = '获取验证码'
              clearInterval(timer)
            }
          }, 1000)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.box {
  border: 1px solid #eee;
  width: 97px;
  text-align: center;
  line-height: 43px;
  height: 45px;
  float: right;
  cursor: pointer;
  overflow: hidden;
  user-select: none;
}
.disabled {
  cursor: not-allowed;
}
.login {
  color: #fff;
  background: #7f7f7f;
}
.login_disabled {
  background: #ccc;
}
</style>
